export const processTypes = {

  GET_A_ORDER_PROCESS_START: "GET_A_ORDER_PROCESS_START",
  GET_A_ORDER_PROCESS_SUCCESS: "GET_A_ORDER_PROCESS_SUCCESS",
  GET_A_ORDER_PROCESS_FAILED: "GET_A_ORDER_PROCESS_FAILED",
  GET_A_ORDER_PROCESS_END: "GET_A_ORDER_PROCESS_END",

};
